/**
 * Smooth-scroll to in-page anchors (#id) with offset for the fixed header group.
 */
(function () {
  'use strict';

  /** Extra gap below the header so the target isn’t flush against it (px). */
  var EXTRA_SCROLL_GAP = 8;

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  /**
   * Height of the fixed/sticky header area covering the top of the viewport.
   */
  function getHeaderOffset() {
    var group = document.getElementById('header-group');
    if (group instanceof HTMLElement) {
      var rect = group.getBoundingClientRect();
      if (rect.height > 0) return Math.round(rect.height);
    }
    var body = document.body;
    var docEl = document.documentElement;
    var fromGroup =
      parseFloat(getComputedStyle(body).getPropertyValue('--header-group-height')) ||
      parseFloat(getComputedStyle(docEl).getPropertyValue('--header-group-height'));
    if (Number.isFinite(fromGroup) && fromGroup > 0) return Math.round(fromGroup);
    var fromHeader = parseFloat(getComputedStyle(body).getPropertyValue('--header-height'));
    if (Number.isFinite(fromHeader) && fromHeader > 0) return Math.round(fromHeader);
    return 0;
  }

  function scrollToHash(hash) {
    if (!hash || hash === '#') return false;
    var raw = hash.charAt(0) === '#' ? hash.slice(1) : hash;
    if (!raw) return false;
    var id;
    try {
      id = decodeURIComponent(raw);
    } catch (e) {
      id = raw;
    }
    var target = document.getElementById(id);
    if (!target && typeof document.getElementsByName === 'function') {
      var byName = document.getElementsByName(id);
      target = byName && byName.length ? byName[0] : null;
    }
    if (!target || !(target instanceof HTMLElement)) return false;

    var offset = getHeaderOffset() + EXTRA_SCROLL_GAP;
    var top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({
      top: Math.max(0, top),
      behavior: prefersReducedMotion() ? 'instant' : 'smooth',
    });
    return true;
  }

  function isModifiedClick(e) {
    return e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0;
  }

  document.addEventListener(
    'click',
    function (e) {
      if (isModifiedClick(e)) return;
      var a = e.target.closest('a[href]');
      if (!a || !(a instanceof HTMLAnchorElement)) return;
      if (a.hasAttribute('download')) return;
      var hrefAttr = (a.getAttribute('href') || '').trim();
      if (!hrefAttr || hrefAttr.indexOf('#') === -1) return;

      var url;
      try {
        url = new URL(a.href);
      } catch (e) {
        return;
      }
      if (url.origin !== window.location.origin) return;
      if (url.pathname !== window.location.pathname) return;
      if (url.search !== window.location.search) return;
      if (!url.hash || url.hash === '#') return;

      if (!scrollToHash(url.hash)) return;
      e.preventDefault();
      if (history.pushState) {
        history.pushState(null, '', url.pathname + url.search + url.hash);
      } else {
        window.location.hash = url.hash;
      }
    },
    false
  );

  function runInitialHash() {
    if (window.location.hash && window.location.hash.length > 1) {
      scrollToHash(window.location.hash);
    }
  }

  if (document.readyState === 'complete') {
    requestAnimationFrame(runInitialHash);
  } else {
    window.addEventListener('load', runInitialHash, { once: true });
  }

  window.addEventListener('hashchange', function () {
    scrollToHash(window.location.hash);
  });
})();
